import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import * as Noty from 'noty';

@Injectable()
export class NotyService {
  trackedNotificationsCount: number = 0;

  constructor(private router: Router) {}

  notify(text: string, type: string = 'info', timeout: any = 5000, layout: string = 'topCenter', otherOptions: any = {}): Noty {
    Noty.overrideDefaults({
      type: type,
      layout: layout,
    });
    let callbacks: any = {};
    let buttons: Array<any> = otherOptions.buttons || [];
    let scope: NotyService = this;
    if (otherOptions.url) {
      buttons.push(
        Noty.button('View', 'btn btn-secondary btn-sm', () => {
          scope.router.navigateByUrl(otherOptions.url);
          notification.close();
        })
      );
      callbacks.onClick = () => {
        scope.router.navigateByUrl(otherOptions.url);
      };
    }
    if (otherOptions.trackNotification && timeout) {
      if (this.trackedNotificationsCount >= 3) timeout *= 2;
      this.trackedNotificationsCount += 1;
      callbacks.afterClose = () => {
        if (scope.trackedNotificationsCount > 0) scope.trackedNotificationsCount -= 1;
        else if (scope.trackedNotificationsCount < 0) scope.trackedNotificationsCount = 0;
      };
    }
    if (otherOptions.closeButtonRequired)
      buttons.push(
        Noty.button('&times;&nbsp;Close', 'btn btn-danger btn-sm', () => {
          notification.close();
        })
      );
    let notification: Noty = new Noty({
      buttons: buttons,
      callbacks: callbacks,
      progressBar: otherOptions.progressBar || false,
      text: text,
      timeout: timeout,
      theme: 'bootstrap-v4',
    });
    notification.show();
    return notification;
  }

  modalNotify(text: string, type: string = 'info', timeout: any = 5000, layout: string = 'center'): Noty {
    Noty.overrideDefaults({
      type: type,
      layout: layout,
    });
    let noty: Noty = new Noty({
      closeWith: [],
      modal: true,
      progressBar: false,
      text: text,
      timeout: timeout,
      theme: 'bootstrap-v4',
    });
    noty.show();
    return noty;
  }
}
